/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 * v1.0.0-beta.82
 */
import { S as Scrim, d as defineCustomElement$1 } from './scrim.js';

const CalciteScrim = Scrim;
const defineCustomElement = defineCustomElement$1;

export { CalciteScrim, defineCustomElement };
